export const columnStyle = {
  container: { 
    display: 'flex', 
    alignItems: 'center', 
    width: '100%', 
    gap: '2px' 
  },
  sequenceNumber: {
    width: '4%',
    fontSize: '12px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    color: 'grey',
    textOverflow: 'ellipsis',
    padding: '0 2px',
    textAlign: 'center'
  },
  orderContainer: { 
    display: 'flex', 
    alignItems: 'center', 
    width: '100%',
    paddingLeft: '4px'
  },
  checkbox: { 
    width: '24px',
    display: 'flex', 
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: '2px'
  },
  orderNumber: { 
    width: '11%', 
    fontSize: '12px', 
    whiteSpace: 'nowrap', 
    overflow: 'hidden', 
    textOverflow: 'ellipsis',
    padding: '0 2px'
  },
  expressNumber: { 
    width: '12%', 
    fontSize: '12px', 
    whiteSpace: 'nowrap', 
    overflow: 'hidden', 
    textOverflow: 'ellipsis',
    padding: '0 2px'
  },
  recipientName: { 
    width: '7%', 
    fontSize: '12px', 
    whiteSpace: 'nowrap', 
    overflow: 'hidden', 
    textOverflow: 'ellipsis',
    padding: '0 2px'
  },
  recipientPhone: {
    width: '9%',
    fontSize: '12px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    padding: '0 2px'
  },
  senderName: {
    width: '8%',
    fontSize: '12px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    padding: '0 2px'
  },
  senderPhone: {
    width: '9%',
    fontSize: '12px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    padding: '0 2px'
  },
  batchNumber: { 
    width: '9%', 
    fontSize: '12px', 
    whiteSpace: 'nowrap', 
    overflow: 'hidden', 
    textOverflow: 'ellipsis',
    padding: '0 2px'
  },
  customer: {
    width: '7%',
    fontSize: '12px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    padding: '0 2px'
  },
  date: { 
    width: '8%', 
    fontSize: '12px', 
    whiteSpace: 'nowrap', 
    overflow: 'hidden', 
    textOverflow: 'ellipsis',
    padding: '0 2px'
  },
  printTimes: {
    width: '4%',
    fontSize: '12px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    padding: '0 2px',
    textAlign: 'center'
  },
  weight: {
    width: '4%',
    fontSize: '12px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    padding: '0 2px',
    textAlign: 'center'
  },
  status: { 
    width: '6%', 
    textAlign: 'center', 
    fontSize: '12px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '0'
  },
  shortPackage: {
    width: '3%',
    textAlign: 'center',
    fontSize: '12px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '0'
  },
  inspection: {
    width: '3%',
    textAlign: 'center',
    fontSize: '12px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '0'
  },
  claim: {
    width: '3%',
    textAlign: 'center',
    fontSize: '12px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '0'
  },
  modified: {
    width: '3%',
    textAlign: 'center',
    fontSize: '12px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '0'
  },
  operation: {
    width: '4%',
    textAlign: 'center',
    fontSize: '12px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '0'
  },
  headerCell: {
    fontSize: '13px',
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: 'flex',
    alignItems: 'center',
    gap: '2px'
  },
  headerCellCenter: {
    fontSize: '13px',
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '2px'
  }
};
